/**
 * Fitnesspilot
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EventFromJSON, EventToJSON } from "./Event";
/**
 * Check if a given object implements the EventRequest interface.
 */
export function instanceOfEventRequest(value) {
    let isInstance = true;
    isInstance = isInstance && "events" in value;
    return isInstance;
}
export function EventRequestFromJSON(json) {
    return EventRequestFromJSONTyped(json, false);
}
export function EventRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        events: json.events.map(EventFromJSON),
    };
}
export function EventRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        events: value.events.map(EventToJSON),
    };
}
